import React, { useCallback, useState } from 'react';
import { SideNavMenuContext } from './SideNavMenuProvider.context';

const SIDEBAR_LOCALSTORAGE_KEY = 'DASHBOARD_SIDE_MENU_OPEN_SECTION';

type SideNavMenuProviderProps = {
  children: React.ReactNode;
};

const getSideBarStateFromLocalStorage = (): string | undefined => {
  return window.localStorage.getItem(SIDEBAR_LOCALSTORAGE_KEY) || undefined;
};

const updateSideBarLocalStorageState = (newState: string | undefined) => {
  if (newState) {
    window.localStorage.setItem(SIDEBAR_LOCALSTORAGE_KEY, newState);
  } else {
    window.localStorage.removeItem(SIDEBAR_LOCALSTORAGE_KEY);
  }
};

export const SideNavMenuProvider = ({ children }: SideNavMenuProviderProps) => {
  const [activeGrouping, updateActiveGrouping] = useState<string | undefined>(
    getSideBarStateFromLocalStorage,
  );

  const setActiveGrouping = useCallback(
    (grouping: string | undefined) => {
      updateActiveGrouping(grouping);
      updateSideBarLocalStorageState(grouping);
    },
    [updateActiveGrouping],
  );

  return (
    <SideNavMenuContext.Provider value={{ activeGrouping, setActiveGrouping }}>
      {children}
    </SideNavMenuContext.Provider>
  );
};
